import {
  faArrowLeft,
  faArrowUpRightFromSquare,
} from "@fortawesome/pro-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faArrowLeft, faArrowUpRightFromSquare);
